// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"27":"4ffbb088","43":"68cd9284","237":"90910cdd","511":"0443d3af","706":"9734a801","739":"045ada0b","817":"85689d8e","895":"2a990ae4","997":"5ff40585"}[chunkId] + ".chunk.css";
};